import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import * as dotenv from 'dotenv';
import Interceptors from './interceptors';

dotenv.config();

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.response.use(
  (response: AxiosResponse<any>) => Interceptors.onResponse(response),
  (error: any) => Interceptors.onError(error),
);

api.interceptors.request.use((config: InternalAxiosRequestConfig) =>
  Interceptors.onRequest(config),
);

export const apiStatus = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

apiStatus.interceptors.response.use(
  (response: AxiosResponse<any>) => Interceptors.onResponse(response),
  (error: any) => Interceptors.onError(error),
);

apiStatus.interceptors.request.use((config: InternalAxiosRequestConfig) =>
  Interceptors.onRequestStatus(config),
);

export const apiEcommerce = axios.create({
  baseURL: process.env.REACT_APP_API_URL_ECOMMERCE,
});

apiEcommerce.interceptors.response.use(
  (response: AxiosResponse<any>) => Interceptors.onResponse(response),
  (error: any) => Interceptors.onError(error),
);

export const apiGeo = axios.create({
  baseURL: process.env.REACT_APP_API_GEO_URL,
});

apiGeo.interceptors.response.use(
  (response: AxiosResponse<any>) => response,
  (error: any) => Interceptors.onError(error),
);

apiGeo.interceptors.request.use((config: InternalAxiosRequestConfig) =>
  Interceptors.onRequest(config),
);

export const apiSession = axios.create({
  baseURL: process.env.REACT_APP_API_SESSION_URL,
});

apiSession.interceptors.response.use(
  (response: AxiosResponse<any>) => Interceptors.onResponseApiSession(response),
  (error: any) => Interceptors.onError(error),
);

apiSession.interceptors.request.use((config: InternalAxiosRequestConfig) =>
  Interceptors.onRequest(config),
);

export const apiReport = axios.create({
  baseURL: process.env.REACT_APP_API_URL_REPORT,
});

apiReport.interceptors.response.use(
  (response: AxiosResponse<any>) => Interceptors.onResponse(response),
  (error: any) => Interceptors.onError(error),
);

apiReport.interceptors.request.use((config: InternalAxiosRequestConfig) =>
  Interceptors.onRequest(config),
);

export const apiGfp = axios.create({
  baseURL: process.env.REACT_APP_API_URL_GFP,
});

apiGfp.interceptors.response.use(
  (response: AxiosResponse<any>) => Interceptors.onResponse(response),
  (error: any) => Interceptors.onError(error),
);

apiGfp.interceptors.request.use((config: InternalAxiosRequestConfig) =>
  Interceptors.onRequest(config),
);

export const apiInternal = axios.create({
  baseURL: process.env.REACT_APP_API_URL_INTERNAL,
});

apiInternal.interceptors.response.use(
  (response: AxiosResponse<any>) => Interceptors.onResponse(response),
  (error: any) => Interceptors.onError(error),
);

apiInternal.interceptors.request.use((config: InternalAxiosRequestConfig) =>
  Interceptors.onRequest(config),
);

export const apiImages = axios.create({
  baseURL: process.env.REACT_APP_API_URL_IMAGES,
});

apiImages.interceptors.response.use(
  (response: AxiosResponse<any>) => Interceptors.onResponse(response),
  (error: any) => Interceptors.onError(error),
);

apiImages.interceptors.request.use((config: InternalAxiosRequestConfig) =>
  Interceptors.onRequest(config),
);

export default api;
